import axios from "axios";
import store from "../store"
import {addToken} from "./user.api";
import CONFIG from "../config/config";
import {loadDictionaries} from "../shared/locales/i18n";
import Base64 from "crypto-js/enc-base64";
import hmacSHA1 from "crypto-js/hmac-sha1";


const httpClient = axios.create({
  baseURL: CONFIG.BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*"
  }
});

httpClient.interceptors.request.use(
  function(config) {
    const tokenInLocalStorage = JSON.parse(localStorage.getItem(store.getters["auth/idTokenKey"]));
    if (tokenInLocalStorage) {
      config.headers = {
        Authorization:
          "Bearer " + tokenInLocalStorage.secret
      };
    }
    if (store.getters["auth/loggedAs"]) {
      if (config.params) {
        config.params.loggedAs = store.getters["auth/loggedAs"].id;
      } else  {
        config.params = {loggedAs: store.getters["auth/loggedAs"].id};
      }
    }

    if (store.getters["auth/connectedRole"] && store.getters["auth/scopeDefault"].is_multirole_enabled) {
      config.headers.connectedRole = store.getters["auth/connectedRole"];
    }

    if(config.url.includes('/worker_contrat_timesheets') || config.url.includes('/submit_worker_contrat_timesheet') ||
      config.url.includes('/approve_timesheets') ||config.url.includes('/reject_timesheets')
      || config.url.includes('/batch_approve_timesheets')
    ) {
      const hmacDigest = Base64.stringify(hmacSHA1(JSON.stringify(config.data), "~^uiW`sfedg4525.3@jyD#~Sdhfb3V^yX|7u<#0dfhgbfx2<A][rgjhv745/'k}2"));
      config.headers['NAuthorization'] = hmacDigest
    }

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

let isAlreadyFetchingIdToken = false;
let subscribers = [];

function onIdTokenFetched(idToken) {
  subscribers = subscribers.filter(callback => callback(idToken));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

function refreshToken() {
  if (!store.getters["auth/refreshToken"]) {
    return;
  }
  const url = "https://"+
    CONFIG.BASE_AZURE_TENANT_NAME +
    ".b2clogin.com/"+
      CONFIG.BASE_AZURE_TENANT_NAME +
    ".onmicrosoft.com/"
    + CONFIG.VUE_APP_AZURE_SIGN_IN_FLOW +
    "/oauth2/v2.0/token";
  const params = new URLSearchParams();
  params.append("grant_type", "refresh_token");
  params.append("client_id", CONFIG.BASE_AZURE_TENANT_CLIENT_ID);
  params.append("refresh_token", store.getters["auth/refreshToken"]);
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
  return axios.post(url, params, config);
}

httpClient.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    console.log(error)

    const {
      config,
      response: { status, data }
    } = error;
    const originalRequest = config;
    if (status === 401 && (data.error === "B8_expired_token" || data.error === "B9_invalid_token") && store.getters["auth/refreshToken"]) {
      if (!isAlreadyFetchingIdToken) {
        isAlreadyFetchingIdToken = true;

        refreshToken().then(
          response => {
            const expiredToken = store.getters["auth/idToken"];

            addToken(response.data.id_token, "refresh_token", expiredToken).then(
              () => {
                store.commit("auth/setTokens", {
                  newIdToken: response.data.id_token,
                  newRefreshToken: response.data.refresh_token
                });
                loadDictionaries();
                isAlreadyFetchingIdToken = false;
                onIdTokenFetched(response.data.id_token);
              },
              () => {
                store.dispatch("auth/logout");
              }
            )

          },
          () => {
            store.dispatch("auth/logout");
          }
        );

      }

      return new Promise(resolve => {
        addSubscriber(response => {
          originalRequest.headers.Authorization = "Bearer " + response;
          resolve(axios(originalRequest));
        });
      });
    } else if (!store.getters["auth/refreshToken"]) {
      store.dispatch("auth/logout");
    }
    return Promise.reject(error);
  }
);

const objectToUrlParams= (obj) => {
  const params = Object.keys(obj)
    .filter(key => obj[key] !== null && obj[key] !== undefined && obj[key] !== '')
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    .join('&');
  return params.length > 0 ? '?' + params : '';
}
export default httpClient;
export {
  objectToUrlParams,
}
